'use client';

import { useTranslations } from 'next-intl';
import LandingHero from '../../organisms/LandingHero/LandingHero';
import { motion } from 'framer-motion';

export default function LandingTemplate() {
  const t = useTranslations('LandingPage');

  return (
    <div className="flex-1 flex flex-col min-h-screen relative selection:bg-pink-500 selection:text-white">
      {/* Sticky Premium Header */}
      <header className="sticky top-0 z-50 w-full bg-zinc-950/10 dark:bg-zinc-950/10 backdrop-blur-md border-b border-zinc-900/50">
        <div className="max-w-[80rem] mx-auto px-[1.5rem] md:px-[4rem] h-[4rem] flex items-center justify-between">
          <motion.div 
            initial={{ opacity: 0, x: -20 }}
            animate={{ opacity: 1, x: 0 }}
            className="flex items-center gap-[0.5rem]"
          >
            <span className="text-[1.25rem] font-black tracking-widest text-pink-primary dark:text-pink-primary">
              {t('title')}
            </span>
          </motion.div>

          <nav className="hidden md:flex items-center gap-[2rem]" aria-label="Navegación Principal">
            <a href="#features" className="text-[0.875rem] font-medium text-zinc-400 dark:text-zinc-400 hover:text-zinc-50 dark:hover:text-zinc-50 transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-primary outline-none">
              {t('nav.features')}
            </a>
            <a href="#about" className="text-[0.875rem] font-medium text-zinc-400 dark:text-zinc-400 hover:text-zinc-50 dark:hover:text-zinc-50 transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-primary outline-none">
              {t('nav.about')}
            </a>
            <a href="#contact" className="text-[0.875rem] font-medium text-zinc-400 dark:text-zinc-400 hover:text-zinc-50 dark:hover:text-zinc-50 transition-colors focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-pink-primary outline-none">
              {t('nav.contact')}
            </a>
          </nav>

          <motion.div 
            initial={{ opacity: 0, x: 20 }}
            animate={{ opacity: 1, x: 0 }}
          >
            <button 
              className="px-[1.25rem] py-[0.5rem] bg-zinc-900 hover:bg-zinc-800 active:scale-[0.98] disabled:opacity-50 text-zinc-50 font-medium rounded-full border border-zinc-800 transition-all focus-visible:outline-2 focus-visible:outline-offset-2 focus-visible:outline-zinc-50 outline-none"
              aria-label={t('cta')}
            >
              {t('cta')}
            </button>
          </motion.div>
        </div>
      </header>

      {/* Main Landing Content with 3D Backdrop */}
      <main className="flex-1 flex flex-col">
        <LandingHero />
      </main>

      {/* Footer */}
      <footer className="w-full bg-zinc-950 border-t border-zinc-900 py-[2rem]">
        <div className="max-w-[80rem] mx-auto px-[1.5rem] md:px-[4rem] flex flex-col md:flex-row items-center justify-between gap-[1rem]">
          <span className="text-[0.875rem] font-bold text-zinc-500">
            &copy; {new Date().getFullYear()} {t('title')}
          </span>
          <span className="text-[0.875rem] text-zinc-500">
            {t('footer.rights')}
          </span>
        </div>
      </footer>
    </div>
  );
}
